import { Switch } from '@headlessui/react'
import { useContext, useEffect, useRef, useState } from 'react'
import { JobListContext, JobStateFilters } from '@/context/jobListContext'

interface iProps {
  title: string
  className?: string
  name: keyof JobStateFilters
  onChange: (value: boolean, key: string) => void
  value?: boolean
}

const Toggle = ({
  title,
  className,
  onChange,
  name,
  value = false,
  ...rest
}: iProps) => {
  const [enabled, setEnabled] = useState(value)
  const { state, dispatch } = useContext(JobListContext)
  const filters: JobStateFilters | null = state.filters ? state.filters : null
  const isMountedEnabled = useRef(false)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMountedEnabled.current) {
      onChange(enabled, name)
    } else {
      isMountedEnabled.current = true
    }
  }, [enabled])

  useEffect(() => {
    if (isMounted.current) {
      if (filters) {
        setEnabled(filters[name] as boolean)
      }
    } else {
      isMounted.current = true
    }
  }, [state])

  return (
    <div
      className={`${className} flex items-center w-full md:w-auto py-6 md:py-0 justify-between md:justify-start `}
    >
      <Switch
        {...rest}
        checked={enabled}
        onChange={(e: any) => {
          setEnabled(!enabled)
        }}
        className={`${enabled ? 'bg-black' : 'bg-gray'}
          relative inline-flex flex-shrink-0 h-10 w-16 md:h-8 md:w-14 border-4 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 order-2 md:order-1`}
      >
        <span className='sr-only'>Use setting</span>
        <span
          aria-hidden='true'
          style={{ top: '-1px' }}
          className={`${enabled ? 'translate-x-6' : 'translate-x-0'}
            pointer-events-none relative inline-block h-8 w-8 md:h-6 md:w-6 rounded-full bg-white border border-white transform ring-0 transition ease-in-out duration-200`}
        />
      </Switch>
      <p className='pl-2 order-1 md:order-2 text-2xl md:text-base '>{title}</p>
    </div>
  )
}

export default Toggle
